import React from "react";
import Chart from "react-apexcharts";

const AvgResolutionTimeChart = ({}) => {
  const data = [
    { site: "Site 02", days: 12.5 },
    { site: "Site 03", days: 9.1 },
    { site: "Site 01", days: 8.5 },
    { site: "Site 06", days: 7.4 },
    { site: "Site 04", days: 6.7 },
    { site: "Site 05", days: 7.5 },
    { site: "Site 07", days: 9.6 },
  ];
  const options = {
    chart: {
      type: "bar",
      toolbar: {
        show: false,
      },
    },

    colors: ["#6366f1"],

    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: "70%",
        distributed: false,
      },
    },

    dataLabels: {
      enabled: false,
    },

    legend: {
      show: false,
    },

    xaxis: {
      categories: data.map((item) => item.site),
      labels: {
        style: {
          fontSize: "12px",
        },
      },
    },

    yaxis: {
      title: {
        text: "",
      },
      min: 0,
      max: 14,
      tickAmount: 7,
    },

    grid: {
      borderColor: "#e5e7eb",
    },

    tooltip: {
      y: {
        formatter: (value) => `${value} days`,
      },
    },
  };

  const series = [
    {
      name: "Average Resolution Time",
      data: data.map((item) => item.days),
    },
  ];

  return (
    <>
      <div className="p-3">
        <Chart options={options} series={series} type="bar" height={230} />
      </div>
    </>
  );
};

export default AvgResolutionTimeChart;
